import { useQuery } from "@tanstack/react-query";
import { fetchLists } from "../config";
import { FetchStructureInterface } from "../types";

const useFetchStructure = ({queryKey, payload, path, enabled}: FetchStructureInterface) => {
  const {data} = useQuery({
      queryKey: queryKey,
      queryFn: () => fetchLists(payload, path),
      refetchOnWindowFocus: false,
      enabled: enabled
    });
  return {
    data
  }
};

export default useFetchStructure;